// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   // Use a more descriptive name, like 'currentUser' or 'userProfile'
//   currentUser: null,
// };

// export const userSlice = createSlice({
//   name: 'user',
//   initialState,
//   reducers: {
//     // A more concise and descriptive action name
//     setUser: (state, action) => {
//       // The payload name can be changed if it represents a specific object, like 'userPayload'
//       state.currentUser = action.payload;
//       console.log('User details updated:', action.payload);
//     },
//      clearUser: (state) => {
//      state.currentUser = null;
//      }
//   },
// });

// // Action creators are now generated for the new reducer names
// export const { setUser, clearUser } = userSlice.actions;

// // The default export remains the same
// export default userSlice.reducer;

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentUser: null,
  // New state: used to track if we've checked the user's login status yet
  isInitialized: false, 
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.currentUser = action.payload;
      state.isInitialized = true; // Mark as done checking
      console.log('User details updated:', action.payload);
    },
    clearUser: (state) => {
      state.currentUser = null;
      state.isInitialized = true; // Even if logged out, the check is complete
    },
    // New action: specifically for when the app starts up
    setInitialized: (state) => {
      state.isInitialized = true;
    }
  },
});

export const { setUser, clearUser, setInitialized } = userSlice.actions;
export default userSlice.reducer;